import { render, staticRenderFns } from "./mailwizzes.vue?vue&type=template&id=2585e3b0&"
import script from "./mailwizzes.ts?vue&type=script&lang=js&"
export * from "./mailwizzes.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports